import React from "react";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import Speaker from "./index";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./styles.css";

import { Pagination, Navigation } from "swiper/modules";

const SpeakersCarousel = ({ speakers, title, cardColor }) => {
  return (
    <div className="speakersCarousel">
      <h2
        className="speakersCarouselHeading"
        style={{
          paddingBottom: "5px",
          fontFamily: "Raleway, Arial, sans-serif",
          textAlign: "center !important",
          display: "block",
        }}
      >
        {title}
      </h2>
      <Swiper
        breakpoints={{
          450: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        modules={[Pagination, Navigation]}
        slidesPerView={1}
        spaceBetween={20}
        navigation
        pagination={{ clickable: true }}
        className="mySwiper"
      >
        {speakers?.map((speaker, i) => (
          <SwiperSlide key={String(i)}>
            <Speaker {...speaker} cardColor={cardColor} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

SpeakersCarousel.propTypes = {
  speakers: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  cardColor: PropTypes.string.isRequired,
};

export default SpeakersCarousel;
